import { Roles } from '@/entities/roles'
import { USER_ROLE_KEY } from '@/features/auth'
import { DisputStatusIcons, DisputStatusTitles } from '@/features/orders/model/constants'
import { DisputListModel, DisputStatus } from '@/features/orders/model/types'
import { formatCardOrPhone } from '@/features/orders/utils/formatCardOrPhone'
import { getDisputAmount } from '@/features/orders/utils/getDisputAmount'
import { renderActionButton } from '@/features/orders/utils/renderActionButton'
import DeviceIcon from '@/shared/assets/icons/deviceOrder.svg?react'
import RequisiteIcon from '@/shared/assets/icons/requisiteOrder.svg?react'
import { BaseCard } from '@/shared/components'
import { BaseCopyButton } from '@/shared/components/BaseCopyButton/BaseCopyButton'
import { OrderIcon } from '@/shared/components/icons/OrderIcon'
import { ItemLayout } from '@/shared/components/ItemLayout/ItemLayout'
import { formatDate } from '@/shared/lib/date'
import { getStorageItem } from '@/shared/lib/storage/localStorage'
import { getShortenId } from '@/shared/utils/getShortenId'
import { useNavigate } from 'react-router-dom'
import { formatCurrency } from '@/shared/lib'
import { Currencies } from '@/entities/curency'

export const MobileBlockOrder = ({
  disput,
  openDisputDialog,
  inProgressDisputDialog,
}: {
  disput: DisputListModel
  openDisputDialog: (id: string) => void
  inProgressDisputDialog: (id: string) => void
}) => {
  const userRole = getStorageItem<Roles | null>(USER_ROLE_KEY, null)
  const isTrader = userRole === Roles.Trader
  const navigate = useNavigate()

  const handleCardClick = () => {
    navigate(`/orders/${disput.id}`)
  }

  const openDialogHandler =
    disput.status === DisputStatus.Created || DisputStatus.Reopened
      ? openDisputDialog
      : inProgressDisputDialog

  const { disputAmountUSDT, disputAmountRub } = getDisputAmount(disput)

  return (
    <BaseCard className="md:hidden flex flex-col gap-[30px] mb-4 last:mb-0 px-5 text-sm">
      <div onClick={handleCardClick} className="cursor-pointer">
        <div className="flex justify-between gap-2 mb-6">
          <ItemLayout
            icon={<OrderIcon status={DisputStatusIcons[disput.status]} />}
            title={DisputStatusTitles[disput.status]}
            subtitle={formatDate(disput.createdAt)}
          />
        </div>
        <div className="flex justify-between mb-4">
          <span className="font-medium text-lg">
            {formatCurrency(disputAmountRub, Currencies.RUB)}
          </span>
          <span className="text-text-secondary">
            {formatCurrency(disputAmountUSDT, Currencies.USDT)}
          </span>
        </div>
        <div className="flex justify-between mb-4">
          <span className="text-text-secondary">ID сделки:</span>
          <div className="flex items-center gap-1">
            <span className="font-medium text-primary">{getShortenId(disput.id, 'long')}</span>
            {<BaseCopyButton text={disput.id} color="primary" size="mini" />}
          </div>
        </div>
        <div className="mb-4">
          <span className="inline-block mb-2 text-text-secondary">Реквизит:</span>
          <ItemLayout
            icon={<RequisiteIcon />}
            subtitle={disput.bankName || ''}
            title={formatCardOrPhone(disput.cardNumber ?? '')}
          />
        </div>
        {isTrader && (
          <div>
            <span className="inline-block mb-2 text-text-secondary">Устройство:</span>
            <ItemLayout
              icon={<DeviceIcon />}
              subtitle={disput.deviceName}
              title={disput.deviceId}
            />
          </div>
        )}
      </div>
      {isTrader && renderActionButton({ disput, openDialog: openDialogHandler })}
    </BaseCard>
  )
}
